import ReactLenis from "lenis/react";

export const SmoothScroll = ({ speed=0.5, duration=1.5, smoothWheel=true, children }) => {

  return (
    <ReactLenis
      root
      options={{
        lerp: speed, // Scrolling speed (lower = smoother)
        duration: duration, // Scroll animation duration in seconds
        smoothWheel, // Smooth out mouse wheel momentum
        allowNestedScroll: true,
        wheelMultiplier: 1.125,
      }}
    >
      {children}
    </ReactLenis>
  );
};
